import React, { useState } from 'react';
import { View, Image, StyleSheet, ImageBackground, ActivityIndicator, Text } from 'react-native';
import background from "../assets/img/background.png"
import * as Animatable from 'react-native-animatable';

import ErrorImage from '../assets/img/error.png';

import Colors from '../constants/colors';
import Texts from '../constants/texts';

const DEFAULT_CLIENT_CONTACT = 'soportetecnico@fintree.cl'

const JwtErrorTemplate = ({error}) => {

  return (
    <Animatable.View 
      duration={1000}
      animation={"fadeIn"}
      style={styles.container}>
      <ImageBackground source={background} style={styles.container}>
        <View style={styles.errorContainer}>
          <View style={[styles.rowView, { paddingBottom: 50 }]}>
            <Image 
              style={{ height: 150, width: 150, marginRight: 20 }}
              source={ErrorImage} />
            <View style={{width: '60vw'}}>
              <Text style={styles.errorTitle}>{Texts.error}</Text>
              <Text style={styles.errorSubtitle}>{error.message} <Text style={[styles.errorSubtitle, {fontWeight: 700}]}>{process.env.CLIENT_CONTACT || DEFAULT_CLIENT_CONTACT}</Text></Text>
            </View>
          </View>
        </View>
      </ImageBackground>
    </Animatable.View>
  )
}

const styles = StyleSheet.create({
  container: {
    height: '100vh',
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  errorContainer: {
    width: '60%',
  },
  errorStack: {
    borderColor: Colors.white,
    color: Colors.gray,
    borderWidth: 0.5,
    borderRadius: 10,
    backgroundColor: Colors.side_menu_background,
    padding: 30,
    fontSize: 17,
  },
  errorTitle: {
    fontSize: 50,
    color: Colors.danger_dark,
  },
  userFeedbackText: {
    width: '80%',
    padding: 10,
    borderColor: Colors.danger_dark,
    borderWidth: 0.5,
    borderRadius: 10
  },
  errorSubtitle: {
    width: '80%',
    paddingTop: 7,
    fontSize: 20,
    color: Colors.danger_dark,
  },
});

export default JwtErrorTemplate;
